import { useState } from "react";
import { InfoOutlined } from "@mui/icons-material";
import { Box, Divider, IconButton, Popover, Typography } from "@mui/material";
import { WidgetExplanationContent } from "../types";

type WidgetExplanationProps = {
    title: string;
    explanation: WidgetExplanationContent;
    iconColor?: string;
};

export const WidgetExplanation = ({ title, explanation, iconColor }: WidgetExplanationProps) => {
    const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(null);

    return (
        <>
            <IconButton
                size="small"
                aria-label={`Explicação: ${title}`}
                onClick={(event) => {
                    event.stopPropagation();
                    setAnchorElement(event.currentTarget);
                }}
                sx={{ color: iconColor || "text.secondary", p: 0.5 }}
            >
                <InfoOutlined sx={{ fontSize: 16 }} />
            </IconButton>
            <Popover
                open={Boolean(anchorElement)}
                anchorEl={anchorElement}
                onClose={() => setAnchorElement(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Box p={3} maxWidth={380}>
                    <Typography variant="subtitle2" fontWeight={700} mb={1}>
                        {title}
                    </Typography>
                    {explanation.metricDefinitions && (
                        <Box mb={2}>
                            {explanation.metricDefinitions.map((metricDefinition) => (
                                <Typography key={metricDefinition.metric} variant="body2" color="text.secondary" mb={1}>
                                    <Box component="span" fontWeight={700} color="text.primary">
                                        {metricDefinition.metric}:
                                    </Box>{" "}
                                    {metricDefinition.definition}
                                </Typography>
                            ))}
                        </Box>
                    )}
                    <Typography variant="body2" color="text.secondary" whiteSpace="pre-line">
                        {explanation.queryDescription}
                    </Typography>
                    {explanation.warningNote && (
                        <Typography variant="body2" color="error.main" fontWeight={600} mt={1.5}>
                            {explanation.warningNote}
                        </Typography>
                    )}
                    {explanation.businessNote && (
                        <>
                            <Divider sx={{ my: 2 }} />
                            <Typography variant="body2" fontStyle="italic">
                                {explanation.businessNote}
                            </Typography>
                        </>
                    )}
                </Box>
            </Popover>
        </>
    );
};
